export default "__VITE_ASSET__CagLu9jk__"